export enum DataFieldValueMode {
    Manual = "Manual",
    Calculated = "Calculated"
}